<template>
    <div class="betContent">
        <template v-if="!closeBetContent">
            <template v-if="row.source_type == 'ob_lottery' || row.source_type == 'sgwin_lottery'">
                <span :class="['text-' +  row.source_type]">{{ row["gameName"] }}</span><br />
                <template  v-if="row.eventId != '' && row.eventId != null">
                    <span style="color: black">[{{ row['eventId'] }}]</span><br>
                </template>

                <template v-if="row.selection != ''" style="white-space: pre;">
                    <span class="text-green" >{{ row["selection"] }}</span><br>
                </template>

                <!-- 雙贏彩票的特有欄位 -->
                <template v-if="row.bet_code" >
                    <span class="text-green" >[{{ row["betCode"] }}]</span><br>
                </template>

                <!-- OB彩票的特有欄位 -->
                <template v-if="row.bet_content" >
                    <span class="text-green" >[{{ row["bet_content"] }}]</span>
                </template>

                <div>
                    <span>@</span>
                    <span class="text-red">{{ row["odds"] }}</span>
                </div>
      

            </template>
            <template v-else>
                <span :class="['text-' +  row.source_type]">{{ row["gameName"] }}</span><br />
                <template  v-if="row.eventId != '' && row.eventId != null">
                    <span style="color: black">[{{ row['eventId'] }}]</span><br>
                </template>

                <template v-if="row.selection != ''" style="white-space: pre-line;">
                    <span class="text-green" v-for="(one,index) of row.selection.split('\n')" 
                            v-bind:key="index">{{ one }}<br/></span>
                </template>
                
                <!-- wm_casino的項目 免傭 -->
                <template  v-if="row.commission == 1">
                    <span class="text-green" >({{ $t("column.wm_casino.no_commission") }})</span>
                </template>

                <!-- ob_poker的項目 活動 -->
                <template  v-if="row.game_flag == 1">
                    <span class="text-green" >({{ $t("column.ob_poker.activity") }})</span>
                </template>
            </template>
        </template>
    </div>
</template>

<script>

export default {
    props: {
        row: Object,
        closeBetContent: Boolean,
    },
};
</script>
